// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".graphdonut-section{text-align:center}.graphdonut-section .graphdonut-content{display:inline-block}.graphdonut-section .graphdonut-content .graphdonut-total-container{display:block;font-size:24px;font-weight:700;margin-top:-110px;text-align:center;width:100%}.graphdonut-section .graphdonut-content .graphdonut-total-label{display:block;font-size:12px;text-align:center;text-transform:uppercase;width:100%}", ""]);
// Exports
module.exports = exports;
